import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getPageContent} from '../../Content/actions';

class PageMenu extends Component {
    componentDidMount() {
        const slug = this.props.match.params.slug;

        this.props.getPageContent(slug);
    }

    render() {
        const {pages, loading} = this.props;
        const slug = this.props.match.params.slug;

        if (pages[slug] === null || pages[slug] === undefined || loading) {
            return (
                <Fragment></Fragment>
            );
        }

        const page = pages[slug];

        return (
            <span>{ReactHtmlParser(page.title.rendered)}</span>
        );
    }
}

PageMenu.propTypes = {
    getPageContent: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    pages: state.content.pages,
    loading: state.content.pageLoading,
    errors: state.errors,
});

export default withRouter(connect(mapStateToProps, {getPageContent})(PageMenu));


// WEBPACK FOOTER //
// ./src/features/Content/components/PageMenu.js